module.exports = __webpack_public_path__ + "images/emoji/baby_bottle.1a3bdef895bdd2edeafb.png";